export default __webpack_public_path__ + "static/media/location-required-icon.49246f26.svg";